export default __webpack_public_path__ + "static/media/money_bag_filled_500px.4d6bd722.png";